import ColorPicker from './ColorPicker';
import './ColorPicker.scss';

export default ColorPicker;